<template>
  <div v-show="isCardActiveLocal">
    
    <div class="clickpagequizviewer">
      <div class="vx-row" v-if="question">
        <div class="vx-col w-full mb-2 textcenter">
          <h3>{{ question ? question.title : "" }}</h3>
        </div>
      </div>
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <div v-html="question.questionText"></div>
        </div>
      </div>

      <div v-if="question.imageUrl" class="quizimage">
        <img :src="question.imageUrl" class="clickimageactive" style="width: 100% !important; height: 100%; border-radius:15px;">
      </div>

    </div>
    
    <div class="vx-row pt-3 ml-2 paddingbot">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full"></div>
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full">
        <div v-if="question">
          <ul>
            <li v-for="(option, index) in question.options" :key="index">
              <div class="vx-row pt-3 ml-2">
                <div class="vx-col w-full">
                  <div>
                      <button
                        class="singleselectbuttons resizequillimage"
                        :class="option.isSelected ? 'button_true': 'button_false' "
                        size="large"
                        style="border-radius:15px; word-break: break-word;"
                        v-html="option.optionText"
                        @click="changeInput(option.optionNumber)">
                      </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      isStudent: {
        type: Boolean,
        required: false
      },
      isStandalone: {
        type: Boolean,
        required: false
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          this.$emit("initValues");
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;

        },
        set(val) {
          if (!val) {
            this.$emit("initValues");
          }
        }
      },
    },
    methods:{
      changeInput(number){
        this.question.options.forEach(element => {
          element.isSelected = false;
        });
        this.question.options[number-1].isSelected = true;
        this.question.inputAnswer = number.toString();
      }
    },
  };
</script>

<style lang="scss">
  label::before , label::after{
    top: 0px !important ;
  }
  .resizequillimage{
    z-index: 2;
    
    img{
      padding: 10px;
      max-width: 15vw;
      width: 100%;
    }
  }
  #answerTextArea {
    height: 200px;
  }

  #answerTextArea {
    .vs-component.vs-con-textarea.vs-textarea-primary{
    border-color: rgb(48, 48, 48) !important;
    }
  }

  .textcenter{
    text-align: center !important;
  }

  .quizimage{
    max-width: 40%;
    max-height: 60%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    padding: 20px 0px;
  }

  @media screen and (max-width: 500px) {
    .quizimage{
      max-width: 80%;
      max-height: 90%;
    }
  }

  .singleselectbuttons{
    width: 100%;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    border: none !important;
    text-align: left;
    padding: 20px;
    
    transition: all .2s ease-in-out;

    &:hover{
      transform: scale(1.05);
    }
    
  }

  .paddingbot{
    padding-bottom: 5%;
  }

  .button_true{
    border: 2px solid rgba(var(--vs-primary), 1) !important;
  }
  
</style>
